import CallToAction from './CallToAction.js'
import Nav from './Nav.js'
import {Link} from 'react-router-dom'
import Navp from './Navp.js'
import { useState } from 'react'

export default function HeroSection() {
    let [Click, setClick] = useState(false)
    let clickHandler = function () {
        setClick(!Click)
    }
    return (
        <div>
            <div class="Header-P">
                <img src={require("../../Icon.png")} alt="icon" class="HeaderIcon"/>
                <span onClick={clickHandler} class="stash--burger-classic"></span>
            </div>
            <Navp Click={Click} Close={clickHandler}/>
            <header class="HeroSection">
                <div class="HomeTopBar">
                    <img src={require("../../Icon.png")} alt="icon" height="90px"/>
                    <Nav/>
                </div>
                <div class="textContainer">
                    <h1 class="Title-Large">Search for the Nearest Tutors Around you</h1>
                    <p class="Subtitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies, et ultricies arcu euismod. Donec scelerisque consectetur dapibus. Mauris posuere dolor ac metus dapibus, tincidunt fermentum massa dictum. </p>
                    <div class="cta-p">
                        <Link to="/tutors-list-page" class="Button h" style={{textDecoration: 'none'}}>Search for Tutors</Link>
                        <p class="Description-Medium">Meet our best tutors of all subjects today!</p>
                    </div>
                </div>
            </header>
            <CallToAction/>
        </div>
    )
}